import type { ReactNode } from "react";

import type { UserAppointment } from "~/api";
import type { VisitType } from "~/services";
import { getVisitTypeTitle } from "~/utils";
import { formatVisitDate } from "../utils/visit-date";

interface AppointmentSummaryProps {
  visit: UserAppointment;
  children?: ReactNode;
}

const formatProvider = (provider: UserAppointment["provider"]): string => {
  if (!provider) return "";
  if (!provider.title) return provider.name;
  return `${provider.name}, ${provider.title}`;
};

export const AppointmentSummary = ({
  visit,
  children,
}: AppointmentSummaryProps) => {
  const providerLine = formatProvider(visit.provider);

  return (
    <div className="flex items-start gap-4">
      {visit.provider?.image && (
        <img
          src={visit.provider.image}
          alt={visit.provider.name}
          className="size-23 shrink-0 rounded-full object-cover"
        />
      )}
      <div className="flex min-w-0 flex-col gap-2">
        <p className="text-indigo font-sans text-base font-medium xl:text-lg">
          {visit.appointment_type.duration}-min{" "}
          {getVisitTypeTitle(visit.appointment_type.slug as VisitType)}
        </p>
        <div>
          {providerLine && (
            <p className="font-sans text-base font-medium leading-5 xl:text-lg">
              {providerLine}
            </p>
          )}
          <p className="text-sm xl:text-lg">
            {formatVisitDate(visit.date, visit.timezone)}
          </p>
          {children}
        </div>
      </div>
    </div>
  );
};
